/**
 * Browser CSRF token for cookie-authenticated POST /api/* mutations.
 * Server validates via requireCsrf (X-CSRF-Token + __csrf cookie).
 */

export function getCsrfTokenFromClient(): string {
  if (typeof document === 'undefined') return '';
  const match = document.cookie.match(/__csrf=([^;]+)/);
  return (
    match?.[1] || (typeof window !== 'undefined' && (window as unknown as { __csrfToken?: string }).__csrfToken) || ''
  );
}

export async function ensureCsrfToken(): Promise<string> {
  let token = getCsrfTokenFromClient();
  if (token) return token;
  try {
    const res = await fetch('/api/csrf/token', { credentials: 'include' });
    if (res.ok) {
      const json = (await res.json()) as { token?: string };
      token = json?.token || '';
      if (token && typeof window !== 'undefined') {
        (window as unknown as { __csrfToken?: string }).__csrfToken = token;
      }
    }
  } catch {
    // Falls back to the CSRF cookie below; if that's missing too, the write gets a CSRF 403,
    // which apiClient already surfaces to the user.
  }
  return token || getCsrfTokenFromClient();
}
